<template>
    <div id="attorneyInfoModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="attorneyInfoTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="attorneyInfoTitle">{{ title }} Attorney Information</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div v-if="attorney" class="modal-body">
                    <div v-if="message" class="alert alert-danger" role="alert">
                        {{ message }}
                    </div>
                    <input type="text" class="form-control form-control-sm mb-1" v-model="attorney.name" placeholder="Attorney Name" required>
                    <input type="text" class="form-control form-control-sm my-2" v-model="attorney.address" placeholder="Address">
                    <input type="text" class="form-control form-control-sm my-2" v-model="attorney.city" placeholder="City">
                    <div class="row my-2">
                        <div class="col-sm-6">
                            <select  class="custom-select custom-select-sm" v-model="attorney.state">
                                <option disabled value="" hidden>Choose State</option>
                                <option v-for="state in states" :key="'attorney-info-' + state.code" :value="state.code" v-text="state.name"></option>
                            </select>
                        </div>
                        <div class="col-sm-6">
                            <input type="text" class="form-control form-control-sm" v-model="attorney.postal_code" placeholder="Postal Code">
                        </div>
                    </div>                    
                    <input type="text" class="form-control form-control-sm my-2" v-model="attorney.email" placeholder="Email">
                    <div class="row mt-1">
                        <div class="input-group input-group-sm col-sm-6">
                            <telephone-input class="form-control" v-model="attorney.phone" placeholder="Phone"></telephone-input>
                            <div class="input-group-append">
                                <span class="input-group-text fas fa-phone"></span>
                            </div>                                 
                        </div>
                        <div class="input-group input-group-sm col-sm-6">
                            <telephone-input class="form-control" v-model="attorney.fax" placeholder="Fax"></telephone-input>
                            <div class="input-group-append">
                                <span class="input-group-text fas fa-fax"></span>
                            </div>                                 
                        </div>                        
                    </div>                                       
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default mr-auto" @click="remove()">Remove</button>
                    <button class="btn btn-primary" @click="update()">Done</button>                    
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
import { AttorneyType } from '../../constants.js';

export default {
    props: {
        claimId: Number,
        states: Array
    },
    data() {
        return {

            AttorneyType: AttorneyType,

            attorneyTypeId: null,
            title: null,
            attorney: {
                name: null,
                address: null,
                city: null,
                state: '',
                postal_code: null,
                email: null,
                phone: null,
                fax: null
            },
            callback: null,
            message: null
        }
    },
    methods: {
        show: function (typeId, title, attorney, callback) {
            this.reset();

            this.attorneyTypeId = typeId;
            this.title = title;

            if (attorney) {
                this.attorney = JSON.parse(JSON.stringify(attorney));
            }
            else {
                this.reset();
            }

            this.callback = callback;
            this.message = null;
            $('#attorneyInfoModal').modal('show');
        },
        update: function () {
            if (this.validate()) {
                this.callback(this.attorney);
                $('#attorneyInfoModal').modal('hide');
            }
        },
        remove: function () {
            this.reset();
            this.callback(null);
            $('#attorneyInfoModal').modal('hide');
        },
        reset: function () {          
            this.attorney = {
                name: null,
                address: null,
                city: null,
                state: '',
                postal_code: null,
                email: null,
                phone: null,
                fax: null
            };
        },
        validate: function () {

            if (!this.attorney.name) {
                this.message = 'Attorney name is a required field.';
                return false;
            }

            return true;
        }
    },
    created() {
        eventHub.$on('show-attorney-info', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-attorney-info');
    }    
}
</script>

<style scoped>
    .alert-condensed {
        font-size: .90em;
        line-height: 1.2em !important;
    }
</style>